import { useCallback, useState } from 'react';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIPopover from 'UIComponents/tooltip/UIPopover';
import UIPopoverBody from 'UIComponents/tooltip/UIPopoverBody';
import UIPopoverCloseButton from 'UIComponents/tooltip/UIPopoverCloseButton';
import UITruncateString from 'UIComponents/text/UITruncateString';
import UIBox from 'UIComponents/layout/UIBox';
import UITextArea from 'UIComponents/input/UITextArea';
import { getTransferrableProps } from '../../../utils/getTransferrableProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const TextAreaPopover = props => {
  const {
    property,
    value,
    inputRef,
    onChange,
    popoverProps
  } = props;
  const [showPopover, setShowPopover] = useState(true);
  const handleChange = event => {
    return onChange(event);
  };
  const renderContent = () => {
    return /*#__PURE__*/_jsxs(UIPopoverBody, {
      className: "p-bottom-5",
      children: [/*#__PURE__*/_jsxs(UIFlex, {
        justify: "between",
        children: [/*#__PURE__*/_jsx("b", {
          children: property.label
        }), /*#__PURE__*/_jsx(UIPopoverCloseButton, {
          onClick: () => setShowPopover(false)
        })]
      }), /*#__PURE__*/_jsx(UIBox, {
        className: "m-top-2",
        children: /*#__PURE__*/_jsx(UITextArea, Object.assign({}, getTransferrableProps(props), {
          value: value === null ? '' : value,
          inputRef: inputRef,
          onChange: handleChange,
          styled: true,
          rows: 6
        }))
      })]
    });
  };
  const handleOpenChange = useCallback(evt => {
    setShowPopover(evt.target.value);
  }, []);
  const handleClick = useCallback(() => {
    setShowPopover(prev => !prev);
  }, []);
  return /*#__PURE__*/_jsx(UIPopover, Object.assign({
    width: 400,
    placement: "right"
  }, popoverProps, {
    open: showPopover,
    renderContent: renderContent,
    onOpenChange: handleOpenChange,
    "data-test-id": "property-input-text-area-popover",
    children: /*#__PURE__*/_jsx(UIBox, {
      onClick: handleClick,
      children: /*#__PURE__*/_jsx(UITruncateString, {
        tooltip: !showPopover,
        children: value
      })
    })
  }));
};
export default TextAreaPopover;